var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box wrapper-salary-receipt-employee" }, [
    _c(
      "h2",
      {
        staticClass: "title is-4 has-text-primary title-salary-receipt-employee"
      },
      [_vm._v("\n    Datos del Empleado\n  ")]
    ),
    _c("div", { staticClass: "columns is-multiline" }, [
      _c(
        "div",
        { staticClass: "column is-12" },
        [
          _c(
            "BField",
            {
              attrs: {
                "label-for": "name-search",
                label: "Buscar/crear empleado por nombre"
              }
            },
            [
              _c(
                "BAutocomplete",
                {
                  attrs: {
                    id: "name-search",
                    value: _vm.text,
                    field: "name",
                    placeholder: "Nombre del empleado",
                    data: _vm.basicEmployees,
                    loading: _vm.isFetching,
                    "open-on-focus": ""
                  },
                  on: { select: _vm.onSelect, input: _vm.onInput },
                  nativeOn: {
                    keyup: function($event) {
                      return _vm.getEmployeesByName($event)
                    }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(props) {
                        return [
                          _c("div", { staticClass: "media" }, [
                            _c("div", { staticClass: "media-content" }, [
                              _vm._v(
                                "\n                Nombre: " +
                                  _vm._s(props.option.name) +
                                  " "
                              ),
                              _c("br"),
                              _c("small", [
                                _vm._v(
                                  "\n                  CURP: " +
                                    _vm._s(props.option.curp) +
                                    "\n                "
                                )
                              ])
                            ])
                          ])
                        ]
                      }
                    }
                  ])
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c(
                        "RouterLink",
                        {
                          staticClass: "button is-text",
                          attrs: { to: { name: "PushBasicEmployee" } }
                        },
                        [_c("span", [_vm._v("Crear empleado")])]
                      )
                    ],
                    1
                  ),
                  _c("template", { slot: "empty" }, [
                    _vm._v(
                      "\n            No se encontraron empleados con este nombre\n          "
                    )
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-12" },
        [
          _c(
            "BField",
            { attrs: { label: "Email" } },
            [
              _c("BInput", {
                attrs: { disabled: "" },
                model: {
                  value: _vm.email,
                  callback: function($$v) {
                    _vm.email = $$v
                  },
                  expression: "email"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }